export default "__VITE_ASSET__DqVpaV_l__"